var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { TableBodyCell, Menu, IconButton, useToast, Loader } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useTasks, useDeleteTask } from 'app/domains/tasks';
import { TaskStatusEnumEnum } from 'shared/domains/apollo/generated/types';
import { TasksIds } from '../../../types';
import { MenuCellWrapper } from './styled';
export function MenuCell(props) {
    const { taskId, isCompleted, status } = props;
    const { handleEditTask } = useTasks();
    const { mutate, loading } = useDeleteTask();
    const { addToast } = useToast();
    const handleEdit = () => {
        handleEditTask(taskId);
    };
    const handleDelete = () => __awaiter(this, void 0, void 0, function* () {
        try {
            yield mutate(taskId);
            addToast({
                title: t `Task deleted`,
                appearance: 'success',
            });
        }
        catch (deleteMutationError) {
            addToast({
                title: t `An error occurred`,
                appearance: 'danger',
            });
        }
    });
    const completed = isCompleted || status === TaskStatusEnumEnum.Completed;
    return (<TableBodyCell removeExtraPadding headers={TasksIds.dropdownMenu}>
      <Menu.Root target={<MenuCellWrapper>
            <IconButton disabled={loading} appearance="ghost" size="xs">
              {loading ? <Loader /> : <Falcon icon="ellipsis-h"/>}
            </IconButton>
          </MenuCellWrapper>}>
        {!completed && (<Menu.Item disabled={loading} onClick={handleEdit}>
            <Falcon icon="edit"/>
            <Trans comment="Edit list item for task context menu">Edit</Trans>
          </Menu.Item>)}
        <Menu.Item disabled={loading} onClick={handleDelete}>
          <Falcon icon="trash"/>
          <Trans comment="Remove list item for task context menu">Remove</Trans>
        </Menu.Item>
      </Menu.Root>
    </TableBodyCell>);
}
